import {
  SEARCH_PROFILES_PENDING,
  SEARCH_PROFILES_SUCCESS,
  SEARCH_PROFILES_ERROR,
  GET_PROFILES_PENDING,
  GET_PROFILES_SUCCESS,
  GET_PROFILES_ERROR,
  UPDATE_PROFILE_PENDING,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_ERROR,
  CREATE_PROFILE_PENDING,
  CREATE_PROFILE_SUCCESS,
  CREATE_PROFILE_ERROR,
  GET_PROFILE_PENDING,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_ERROR,
  SET_PROFILE_INDEX_SUCCESS,
  REMOVE_PROFILE_ERROR,
  REMOVE_PROFILE_PENDING,
  REMOVE_PROFILE_SUCCESS,
} from "../actions/profile";

const initialState = {
  pending: false,
  pendingUpdate: false,
  profiles: [],
  newProfile: null,
  filters: [1],
  error: null,
};

export function reducer(state = initialState, action) {
  switch(action.type) {
      case GET_PROFILES_PENDING:
          return {
              ...state,
              pending: true
          }
      case GET_PROFILES_SUCCESS:
          return {
              ...state,
              pending:       false,
              filters:    action.payload.filters,
              profiles:      action.payload.profiles,
              totalProfiles: action.payload.total
          }
      case GET_PROFILES_ERROR:
          return {
              ...state,
              pending: false,
              error:   action.error
          }
    case SET_PROFILE_INDEX_SUCCESS:
        return {
            ...state,
            profileIndex: action.payload.profileIndex,
            error:action.error
        }
      case GET_PROFILE_PENDING:
          return {
              ...state,
              pending: true
          }
          case GET_PROFILES_PENDING:
            return {
                ...state,
                pending: true
            }
      case GET_PROFILE_SUCCESS:
          return {
              ...state,
              pending: false,
              profile: action.payload.profile,
              filters:action.payload.filters,
          }
      case GET_PROFILE_ERROR:
          return {
              ...state,
              pendingUpdate: false,
              error:   action.error
          }
      case UPDATE_PROFILE_PENDING:
          return {
              ...state,
              pendingUpdate: true
          }
      case UPDATE_PROFILE_SUCCESS:
          return {
              ...state,
              pendingUpdate:  false,
              profile: action.payload.profile,
          }
      case UPDATE_PROFILE_ERROR:
          return {
              ...state,
              pending: false,
              error: action.error
          }
      case CREATE_PROFILE_PENDING:
          return {
              ...state,
              pending: true
          }
      case CREATE_PROFILE_SUCCESS:
          return {
              ...state,
              pending:  false,
              newProfile: action.payload.profile,
              profiles: state.profiles.concat(action.payload.profile),
          }
      case CREATE_PROFILE_ERROR:
          return {
              ...state,
              pending: false,
              error: action.error
          }
      case SEARCH_PROFILES_PENDING:
          return {
              ...state,
              pending: true,
              
          }
      case SEARCH_PROFILES_SUCCESS:
          return {
            ...state,
            pending: false,
            profiles: action.payload.profiles,
            filters: action.payload.filters,
            totalProfiles: action.payload.total,
          };
      case SEARCH_PROFILES_ERROR:
          return {
              ...state,
              pending: false,
              error: action.error
          }
      case REMOVE_PROFILE_PENDING:
          return {
              ...state,
              pending: true,
          }
      case REMOVE_PROFILE_SUCCESS:
          return {
            ...state,
            pending: false,
            profiles: state.profiles.filter(
              (profile) => profile.id !== action.payload.profile.id
            ),
            newProfile: null,
          };
      case REMOVE_PROFILE_ERROR:
          return {
              ...state,
              pending: false,
              error: action.error
          }
    default:
      return state;
  }
}


export const getProfiles = state => state.profile.profiles;
export const getProfilesStatus = state => state.profile.pending;
export const getProfileIndex = state => state.profile.profileIndex;
export const getProfile = state => state.profile.profile;
export const getProfilesFilters = state => state.profile.filters;
export const getProfilesTotal = state => state.profile.totalProfiles;
export const getProfilesUpdatePending = state => state.profile.pendingUpdate;
export const getProfilesPending = state => state.profile.pending;
export const getProfilesError = state => state.profile.error;
export const searchProfiles = state => state.profile.profiles;
export const getNewProfile = state => state.profile.newProfile;
